// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/6f606c5e6bf0b8e8f40a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"74df230cb84bd22f18be","29":"a4181c6ee536e0e9b889","132":"26ca2ccdd8fb4de3be78","133":"2aba6b476abe79fd82e8"}[chunkId] + ".chunk.js";
};